import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLockOrderMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLockOrder = () => {
  const [handle, { loading, error: apolloError }] = useLockOrderMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    lock: useCallback(
      async (id: string, versionNumber: number) => {
        const res = await handle({ variables: { id, versionNumber } });
        return !!res.data?.lock;
      },
      [handle]
    ),
  };
};
